import { createAsyncThunk } from "@reduxjs/toolkit";
import { Utils } from "../../../shared/utils";
import { specialistFacilityService } from "../../services/implementation-facility-service";


export const getClientFacilities = createAsyncThunk(
  "implementationFacilityContext/getClientFacilities",
  async (clientId: number, thunkAPI) => {
    const response = await specialistFacilityService.getClientFacilities(clientId);
    if (response.hasErrors) {
      Utils.robustErrorHandler(response, thunkAPI);
      return;
    }
    return response.entity;
});

export const getClientFacilityById = createAsyncThunk(
  "implementationFacilityContext/getClientFacilityById",
  async (facilityId: number, thunkAPI) => {
    const response = await specialistFacilityService.getClientFacilityById(facilityId);
    if (response.hasErrors) {
      Utils.robustErrorHandler(response, thunkAPI);
      return;
    }
    return response.entity;
});

export const getClientFacility = createAsyncThunk(
  "implementationSpecialistClientContext/getClientFacility",
  async (data: {clientId: number, facilityId: number}, thunkAPI) => {
    const response = await specialistFacilityService.getClientFacility(data.clientId, data.facilityId);
    if (response.hasErrors) {
      Utils.robustErrorHandler(response, thunkAPI);
      return;
    }
    return response.entity;
  }
);



